<script lang="ts" setup>
import { ref } from "vue"
import LogoInvicta from "@/assets/icons/logo_invicta.svg?component"
import InvictaIcon from "@/assets/icons/invicta_icon.svg?component"
import ArrowIcon from "./../ArrowIcon/ArrowIcon.vue"
import Logout from "./../Logout/Logout.vue"

export interface SidePanel {
   userName?: string
   userEmail?: string
   dataTestId?: string
}

defineProps<SidePanel>()

const isHidden = ref(false)

const toggle = () => {
   isHidden.value = !isHidden.value
   emit("toggle", isHidden.value)
}

const emit = defineEmits<{
   (e: "logout"): void
   (e: "toggle", isHidden: boolean): void
}>()
</script>

<template>
   <div
      class="side-panel"
      :class="{ 'side-panel--hidden': isHidden }"
      :data-test-id="dataTestId"
   >
      <div class="side-panel__top">
         <LogoInvicta v-if="!isHidden" />
         <InvictaIcon v-if="isHidden" class="side-navigation__icon" />
         <div
            class="side-panel__toggler"
            :class="{ 'side-panel__toggler--right': isHidden }"
            @click="toggle()"
         >
            <ArrowIcon />
         </div>
      </div>

      <div class="side-navigation-panel__content">
         <slot name="menu"></slot>

         <div class="side-navigation-panel__additional-content">
            <slot name="content"></slot>
         </div>
      </div>

      <div class="side-panel__bottom">
         <Logout
            :is-hidden="isHidden"
            :user-name="userName"
            :user-email="userEmail"
            :data-test-id="(dataTestId ? `${dataTestId}.` : ``) + `user-data`"
            @logout="$emit('logout')"
         />
      </div>
   </div>
</template>
